import { Suspense } from 'react'
import { Outlet, useNavigate } from 'react-router'
import { ErrorBoundary } from '../../ErrorBoundary'
import { Loader } from '../../Loader'
import { useIsAppointmentGuidesRoute } from '../useAppointmentGuidesRoute'
import { useIsPostAppointmentFormRoute } from '../useIsPostAppointmentForm'
import { Breadcrumbs } from './Breadcrumbs'
import { GlobalStyleOverrides } from './GlobalStyleOverrides'
import { Sidebar } from './Sidebar'
import { useStyles } from './index.styles'
import { useKeyBindings, useUser } from 'hooks'

const Main = () => {
  const classes = useStyles()
  const isPostAppointmentFormRoute = useIsPostAppointmentFormRoute()
  const isAppointmentGuidesRoute = useIsAppointmentGuidesRoute()
  const isStandalonePage = isPostAppointmentFormRoute || isAppointmentGuidesRoute
  const navigate = useNavigate()
  const { roleFlags } = useUser()

  useKeyBindings({
    'i d m': () => {
      if (!roleFlags?.isAdmin) {
        return
      }

      const url = new URL(window.location.href)

      url.searchParams.set('ignoreDeliveryModel', 'true')

      navigate(url.href.replace(url.origin, ''))
    },
  })

  return (
    <Suspense fallback={<Loader hasDelay />}>
      <ErrorBoundary>
        {isStandalonePage ? (
          // TODO: This should be removed when we turn on the side bar navigation permanently
          <GlobalStyleOverrides />
        ) : (
          <nav className={classes.nav}>
            <Sidebar />
          </nav>
        )}
        <main className={classes.main} data-testid="main-container">
          {!isStandalonePage && <Breadcrumbs />}
          <Outlet />
        </main>
      </ErrorBoundary>
    </Suspense>
  )
}

export { Main }
